import { InjectionToken } from '@angular/core';
import { UserLike } from '@context/shared/types/user';
import { BehaviorSubject } from 'rxjs';

export const USER = new InjectionToken<BehaviorSubject<UserLike | null>>(
	'UserToken',
);
